































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Sticky, List } from 'vant';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { isWeiXin } from '@/common/ts/common';
import { getVoteList, getNewsList, getRule } from '../api';
import ListItem from '../components/ListItem.vue';
import NewsList from '../components/NewsList.vue';

Vue.use(Sticky).use(List);
let msnry!: Masonry;
@Component({
  components: {
    ListItem,
    NewsList,
  },
})
export default class Home extends Vue {
  tabbar: any[] = [
    { title: '作品展示', id: 1, scrollPos: 0 },
    { title: '相关新闻', id: 2, scrollPos: 0 },
    { title: '活动简介', id: 3, scrollPos: 0 },
  ];
  activeTab = 0;
  scrollTimer: any = null;
  searchTimer: any = null;
  scrollDistance: number = 0;
  loading = false;
  finished = false;
  page = 1;
  voteList: any[] = [];
  keyword = '';
  rule: any = '';

  @Watch('keyword')
  onKeywordChange(newval: string) {
    if (!newval.length) {
      this.resetVoteList();
      this.onGetVoteList();
    }
  }

  @Watch('$route')
  onRouteChange(newval: any) {
    if (newval.name === '0310WCSJDS-home') {
      this.activeTab = newval.params.tabIndex - 1;
    }
  }

  async created() {
    const retRule = await getRule();
    this.rule = retRule.data;
    // 设置pv和分享
    const cover =
      'https://image2.cqcb.com/d/file/activity/2023-03-14/8edda6734b82a57c01c392a93fa3079d.jpg';
    this.$appShareInfo({
      title: '2023重庆·铜梁文创产品设计大赛',
      url: location.href,
      subtitle: `总奖金100000元！作品征集时间：2023年3月14日至5月15日`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2023重庆·铜梁文创产品设计大赛',
        subtitle: `总奖金100000元！作品征集时间：2023年3月14日至5月15日`,
        image: cover,
      });
    }
    // 获取列表
    this.onGetVoteList();
  }
  mounted() {
    // 记录每个tabContent的滚动位置
    window.addEventListener('scroll', () => {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(() => {
        console.log('记录滚动距离');
        const scrollEl = document.documentElement || document.body;
        this.tabbar[this.activeTab].scrollPos =
          scrollEl.scrollTop || window.pageYOffset;
        // console.log(
        //   'current scrollTop is:',
        //   scrollEl.scrollTop || window.pageYOffset,
        // );
      }, 100);
    });
  }
  onNavTo(item: any, index: number) {
    this.$routerThen
      .push({
        url: `/0310WCSJDS/detail?id=${item.id}`,
      })
      .then((vm) => {
        vm.$on('updateVote', (val: any) => {
          this.voteList[index].votes = Number(this.voteList[index].votes) + 1;
        });
      });
  }
  onTabChange(tabIndex: number) {
    if (tabIndex === this.activeTab) {
      return console.log('deny to nav to current page itself');
    }
    this.activeTab = tabIndex;
    this.$router.push(`/0310WCSJDS/home/${tabIndex + 1}`);
    console.log('new tab index:', tabIndex);
    // 恢复此前页面停留位置
    this.$nextTick(() => {
      window.scrollTo(0, this.tabbar[tabIndex].scrollPos);
    });
  }
  async onGetVoteList() {
    this.loading = true;
    const ret = await getVoteList(this.page, this.keyword);
    this.loading = false;
    if (!ret.data.length) {
      this.finished = true;
    } else {
      this.voteList = [...this.voteList, ...ret.data];
      this.page++;
    }
    this.$nextTick(() => {
      const grid = document.querySelector('.vote-list')!;
      msnry = new Masonry(grid, {
        itemSelector: '.vote-item',
        horizontalOrder: true,
      });
      // imagesLoaded(grid).on('progress', (instance, image) => {
      //   console.log(instance, image);
      // });
      imagesLoaded(grid, () => {
        console.log('all imgs loaded');
        if (msnry.layout) {
          msnry.layout();
        }
      });
    });
  }
  resetVoteList() {
    this.voteList = [];
    this.finished = false;
    this.page = 1;
  }
  onSearch() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    this.searchTimer = setTimeout(() => {
      this.resetVoteList();
      this.onGetVoteList();
    }, 200);
  }
}
